import React, { PropsWithChildren } from "react"
import {
	Grid2,
	CircularProgress
} from "@mui/material"

type FallbackSpinnerProps = PropsWithChildren<{
	isLoading: boolean
}>

export const FallbackSpinner: React.FC<FallbackSpinnerProps> = ({ isLoading, children }) => {
	if (isLoading) {
		return (
			<Grid2
				container
				justifyContent="center"
				alignItems="center"
				sx={{
					height: "100%"
				}}
			>
				<CircularProgress color="secondary" />
			</Grid2>
		)
	}

	return <>{children}</>
}
